<template>
<!-- Button trigger modal --
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#mdContent">
  Launch demo modal
</button>
-->
<!-- Modal -->
<div class="modal fade" id="mdContent" tabindex="-1" aria-labelledby="mdContentLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="mdContentLabel">Modal Content Title ({{name}})</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        usuarios {{users}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { ref, onMounted } from 'vue'
import WspService from "../workSpace.service";

export default {
   setup() {
      const users = ref([])
      const name = ref("")

      onMounted(() => {
         document.getElementById('mdContent')
         .addEventListener('show.bs.modal', function (event) {

            let button = event.relatedTarget

            name.value = button.getAttribute('data-bs-name')
            let id = button.getAttribute('data-bs-id')
            console.log('mounted the modal --> id: '+id);
            getUsers(id)

         })
         console.log('mounted the modal')
      })

   function getUsers(contentId) {
      WspService.getUsers(contentId)
      .then(response => {
         console.log(response.data)
         users.value = response.data
         console.log("response.data ok")
         //let result = response.data
         //return {result: response.data}
      })
      .catch(error => {
         console.log(error);
      });
   }

      return {
         name,
         users
      }
      
   }
   /*
   data() {
      return {
         users: [],
      };
   },
   mounted() {
      this.$nextTick(() => {
         //
         var exampleModal = document.getElementById('mdContent')
         exampleModal.addEventListener('show.bs.modal', function (event) {
            // Button that triggered the modal
            var button = event.relatedTarget
            // Extract info from data-bs-* attributes
            var name = button.getAttribute('data-bs-name')
            console.log('mounted the modal --> name: '+name);
            var id = button.getAttribute('data-bs-id')
            //this.getUsers(id);
            //
         WspService.getUsers(id)
         .then(response => {
            this.users = response.data;
            console.log(response.data);
         })
         .catch(error => {
            console.log(error);
         });
            //
            console.log('mounted the modal --> id: '+id);
            // If necessary, you could initiate an AJAX request here
            // and then do the updating in a callback.
            //
            // Update the modal's content.
            var modalTitle = exampleModal.querySelector('.modal-title')
            ////var modalBodyInput = exampleModal.querySelector('.modal-body input')

            modalTitle.textContent = name;
            ////modalBodyInput.value = recipient
         })
         //
         console.log('mounted the modal');
      });
   },
   methods: {
      getUsers(contentId) {
         WspService.getUsers(contentId)
         .then(response => {
            console.log(response.data);
         })
         .catch(error => {
            console.log(error);
         });
      },      
   },
   */
}
</script>